<div class="dynamic-field form-select col-12" [formGroup]="group">
    <div class="row">
      <div class="col-3">
            <label>{{ config.name }} <span *ngIf="config.validation" style="color: red"> *</span></label>
      </div>
      <div class="col-9" style="margin-bottom: 5px;">
          <!-- <p-dropdown [style]="{'width':'100%'}"  (value)="selectValue" [required]="config.optional" [options]="config.options" placeholder="{{config.placeholder}}" (onChange)="onDDChange($event.value)" i18n ></p-dropdown> -->
          <p-dropdown [style]="{'width':'100%'}" formControlName="{{config.name}}" [(ngModel)]="selectValue" [required]="config.optional" [options]="config.options" placeholder="{{config.placeholder}}" (onChange)="onDDChange($event.value)"  i18n ></p-dropdown>
      </div>
      <div class="col-3" *ngIf="selectedOther">
        <label>Angiv hvilken {{config.name}} <span *ngIf="config.validation" style="color: red"> *</span></label>
      </div>
      <div class="col-9" style="margin-bottom: 5px;" *ngIf="selectedOther">
        <input pInputText type="text" (value)="otherValue" (change)="onInputBlur($event)"/>
      </div>
    </div>
</div>
<!-- [optionLabel]="config.name" [dataKey]="config.price" -->
